import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

import Loading from '../../components/Loading';

const SaveButton = ({ isLoading, isMdButton, areButtonsDisabled, buttonMessage }) => {
  const className = isMdButton ? 'd-none d-md-block' : 'd-block d-md-none';
  if (isLoading)
    return (
      <div className={className}>
        <Loading />
      </div>
    );
  return (
    <Button type="submit" variant="success" disabled={areButtonsDisabled} className={className}>
      {buttonMessage}
    </Button>
  );
};
SaveButton.defaultProps = {
  isMdButton: true
};
SaveButton.propTypes = {
  isMdButton: PropTypes.bool,
  isLoading: PropTypes.bool.isRequired,
  areButtonsDisabled: PropTypes.bool.isRequired,
  buttonMessage: PropTypes.string.isRequired
};

export default SaveButton;
